import { useNavigate } from 'react-router-dom';
import MarketTicker from '../components/MarketTicker';

const css = `
.hero{padding:70px 24px 50px;text-align:center;position:relative;overflow:hidden;}
.hero::before{content:'';position:absolute;top:-60px;left:50%;transform:translateX(-50%);
  width:700px;height:500px;background:radial-gradient(ellipse,rgba(0,194,255,0.07) 0%,transparent 70%);pointer-events:none;}
.hero-eyebrow{font-size:11px;letter-spacing:3px;text-transform:uppercase;color:#1E7FD4;font-weight:600;margin-bottom:14px;}
.hero-title{font-family:'Barlow Condensed',sans-serif;font-size:clamp(44px,8vw,88px);
  font-weight:800;line-height:0.93;letter-spacing:-1px;margin-bottom:18px;}
.hero-title .ac{color:#1E7FD4;} .hero-title .go{color:#6DBE45;}
.hero-sub{font-size:17px;color:#8899AA;max-width:520px;margin:0 auto 36px;line-height:1.65;font-weight:300;}
.hero-btns{display:flex;gap:12px;justify-content:center;flex-wrap:wrap;}
.how-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:14px;margin-bottom:40px;}
.how-card{background:#111C2E;border:1px solid rgba(255,255,255,0.07);border-radius:12px;padding:22px;}
.how-icon{font-size:28px;margin-bottom:10px;}
.how-title{font-family:'Barlow Condensed',sans-serif;font-size:18px;font-weight:700;color:#F0F6FF;margin-bottom:6px;}
.how-desc{font-size:13px;color:#8899AA;line-height:1.6;}
.market-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:10px;margin-bottom:40px;}
.mkt-btn{background:#111C2E;border:1px solid rgba(255,255,255,0.07);border-radius:10px;padding:16px;
  text-align:left;cursor:pointer;transition:all 0.2s;}
.mkt-btn:hover{border-color:rgba(0,194,255,0.3);background:#0F1F38;}
.mkt-name{font-size:13px;font-weight:600;color:#F0F6FF;margin-bottom:4px;}
.mkt-rate{font-family:'Barlow Condensed',sans-serif;font-size:22px;color:#1E7FD4;font-weight:800;}
.footer-ad{background:linear-gradient(135deg,#0F1F38,#1A2B45);border:1px solid rgba(245,166,35,0.15);
  border-radius:12px;padding:22px 26px;display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;margin-bottom:28px;}
.footer-ad-tag{font-size:10px;letter-spacing:2px;text-transform:uppercase;color:#6DBE45;font-weight:600;margin-bottom:6px;}
.footer-ad-title{font-family:'Barlow Condensed',sans-serif;font-size:20px;font-weight:700;color:#F0F6FF;}
.footer-ad-sub{font-size:13px;color:#8899AA;}
`;

const MARKETS = [
  {id:7,name:'Atlanta, GA'},{id:6,name:'Austin, TX'},{id:4,name:'Chicago, IL'},
  {id:1,name:'Dallas, TX'},{id:3,name:'Los Angeles, CA'},{id:5,name:'New York, NY'},{id:2,name:'Virginia (DC Metro)'}
];

export default function HomePage() {
  const nav = useNavigate();
  return (<><style>{css}</style>
    <div className="hero">
      <div className="hero-eyebrow">Verified Professionals · Transparent Rates · Secure Payments</div>
      <h1 className="hero-title">Data Center<br/><span className="ac">Pros</span> on <span className="go">Demand</span></h1>
      <p className="hero-sub">Find vetted, insured, experienced data center technicians in your market — rack & stack, cabling, remote hands, and more.</p>
      <div className="hero-btns">
        <button className="btn btn-primary btn-lg" onClick={()=>nav('/browse')}>Browse Professionals →</button>
        <button className="btn btn-green btn-lg" onClick={()=>nav('/join')}>Join as a Pro</button>
        <button className="btn btn-outline btn-lg" onClick={()=>nav('/register')}>Customer Sign Up</button>
      </div>
    </div>

    <div className="page-container" style={{paddingTop:0}}>
      <MarketTicker />

      <div className="how-grid">
        {[
          {icon:'🔍',title:'Browse Anonymously',desc:'See verified skills, experience and rates — no names until you hire.'},
          {icon:'⭐',title:'Certified First',desc:'BICSI, CompTIA and other certified pros are prioritized at the top of listings.'},
          {icon:'💳',title:'Secure Escrow',desc:'Pay through the platform. Funds release only after job completion. We take 10%.'},
          {icon:'📍',title:'Local Markets',desc:'Real-time market pricing per region. Know if a rate is fair before you commit.'},
        ].map(h=>(
          <div className="how-card" key={h.title}>
            <div className="how-icon">{h.icon}</div>
            <div className="how-title">{h.title}</div>
            <div className="how-desc">{h.desc}</div>
          </div>
        ))}
      </div>

      <div style={{marginBottom:16}}>
        <div className="section-title" style={{marginBottom:12}}>Browse by Market</div>
        <div className="market-grid">
          {MARKETS.map(m=>(
            <button key={m.id} className="mkt-btn" onClick={()=>nav(`/browse?market=${m.id}`)}>
              <div className="mkt-name">{m.name.split(',')[0]}</div>
              <div style={{fontSize:10,color:'#445566',marginBottom:6,textTransform:'uppercase',letterSpacing:0.5}}>Market</div>
              <div className="mkt-rate">Browse →</div>
            </button>
          ))}
        </div>
      </div>

      <div className="footer-ad">
        <div>
          <div className="footer-ad-tag">Sponsor · Advertise on iTekPros</div>
          <div className="footer-ad-title">Reach DC Professionals</div>
          <div className="footer-ad-sub">Advertise your products to verified data center technicians across 7 US markets.</div>
        </div>
        <button className="btn btn-green">Advertise With Us</button>
      </div>
    </div>
  </>);
}
